import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageModalComponent } from '@niceltd/cxone-components/modal';
import { DialogService } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { ModuleExportFormat } from "src/AngularJS/Dashboard/Models/module-export-format.model";
import { DashboardModalModel } from "src/AngularJS/Dashboard/dashboard-modal.component";
import { ModuleContainerService } from "src/app/dashboard/module-container/module-container.service";
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { FeaturesService } from 'src/app/reusables/features.service';
import { TimezoneService } from "src/app/reusables/services/timezone.service";
import { SubscriptionSchedulerService } from 'src/app/reusables/subscription-scheduler/subscription-scheduler.service';
import { DashboardManager } from 'src/shared/models/dashboard-manager';
import { Dashboard, DashboardAccessOptions, DashboardResponsiveApiModel, DashboardResponsiveApiModelSparse, DashboardSelectionListApiModel } from 'src/shared/models/dashboard.model';
import { DashboardModuleResponsiveInstanceForGridster } from 'src/shared/models/module-info.model';
import { ModuleManagerExportFormat } from "src/shared/models/module-manager/module-manager-options.model";
import { FullSubscriptionSchedule } from 'src/shared/models/subscriptions.model';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { DashboardService } from '../../dashboard.service';
import { DashboardAccessComponent } from '../../modals/dashboard-access/dashboard-access.component';
import { DashboardAccessService } from '../../modals/dashboard-access/dashboard-access.service';
import { DeleteSubscriptionComponent } from '../../modals/delete-subscription/delete-subscription.component';
import { DeleteSubscriptionService } from '../../modals/delete-subscription/delete-subscription.service';
import { SubscriptionModalComponent } from '../../modals/subscription-modal/subscription-modal.component';
import { SubscriptionModalService, SubscriptionOptions } from '../../modals/subscription-modal/subscription-modal.service';
import { TemplateListModalComponent } from '../../modals/template-list-modal/template-list-modal.component';

@Component({
    selector: 'cv-dashboard-header',
    templateUrl: './dashboard-header.component.html',
    styleUrls: ['./dashboard-header.component.scss'],
    providers: [DialogService]
})
export class CXOneDashboardHeaderComponent implements OnInit, OnChanges, OnDestroy {

    @Input() filterText = '';
    @Input() isAddingWidgets = false;
    @Input() modules: DashboardModuleResponsiveInstanceForGridster[] = [];
    @Input() publishPending = false;
    @Input() public dashboardManager: DashboardManager;
    //@Input() revertDashboardFilters = new EventEmitter<any>();

    @Output() addingWidget = new EventEmitter(); //tells responsive dashboard that add widget is open

    // Fullscreen Toggle
    @HostListener('document:fullscreenchange', ['$event'])
    @HostListener('document:webkitfullscreenchange', ['$event'])
    @HostListener('document:mozfullscreenchange', ['$event'])
    @HostListener('document:MSFullscreenChange', ['$event'])

    //Public

    isFullscreen = false;
    dashboardIndices: Map<string, number> = new Map();
    openDashboardIndices: Map<string, number> = new Map();
    closingDashboard = false;
    showOptions = false;
    dashboardFilterText = '';
    filteredDashboards = [];
    selectedDashboard: Dashboard;
    availableCxoneListDashboards: DashboardSelectionListApiModel[]; // CXone dashboards available for the user to select
    selectDashboardText: string;
    saveOrCancelTooltip: string;
    localizationReady = false;
    public filledStarUrl = "../App_Themes/CXone/icons/favorite-star.svg#favorite-star";
    public unfilledStarUrl = "../App_Themes/CXone/icons/favorite-star-outline.svg#favorite-star-outline";

    // For Dashboard Filters
    /*isFilterOpen = false;
    selectedFilters = { isValid: true, selection: [] };
    filtersApplied = 0;
    isFiltersApplyButtonEnabled = false;
    applyDashboardFiltersReversion = new EventEmitter<any>();
    disableDuplicateAndCreate = false;
    applyFiltersTooltip = "";*/

    excel: ModuleManagerExportFormat = ModuleManagerExportFormat.Excel;
    noObjectives: ModuleManagerExportFormat = ModuleManagerExportFormat.ExcelNoObjectives;

    //For Subscription
    public schedulerOpened = false;
    public schedulerId: number;
    public schedulerKey: string;
    public subscriptionTitle: string;
    public subscriptionId = -1;
    dashboardSubscriptions: Map<string, FullSubscriptionSchedule>;

    //For Edit
    editOpened = false;

    //For Export
    public disableExport = true;

    public openModal: EventEmitter<DashboardModalModel> = new EventEmitter();

    //Private
    private exportFormats: { [name: string]: ModuleExportFormat } = {};
    private _subscriptions: Subscription[] = [];
    private lastSelectedDashboard = null;
    private subscriptionsFeatureEnabled = false;

    modalRef: NgbModalRef = null;

    constructor(
        public dashboardService: DashboardService,
        public cvLocalizationService: CVLocalizationService,
        public moduleContainerService: ModuleContainerService,
        public navigationService: NavigationService,
        public timezoneService: TimezoneService,
        public dashboardAccessService: DashboardAccessService,
        public modalService: NgbModal,
        private subscriptionService: SubscriptionModalService,
        private schedulerService: SubscriptionSchedulerService,
        private subscriptionDeleteService: DeleteSubscriptionService,
        private CVDialogService: CvDialogService,
        private ngbModal: NgbModal,
        private featuresService: FeaturesService,
        private dialogService: DialogService,
    ) {
        // export formats
        this.exportFormats = {
            csv: {
                description: 'CSV',
                mime: 'text/csv',
                extension: 'csv',
            },
            excel: {
                description: 'Excel',
                mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                extension: 'xlsx',
            },
            excelNoObjectives: {
                description: 'Excel',
                mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                extension: 'xlsx',
            },
        };

        this.getLocaleText = cvLocalizationService.getCachedText.bind(cvLocalizationService, "CXOne_Dashboard");

        // Load the subscription for the active dashboard
        this.loadActiveDashboardSubscription();

        // Load the dropdown for the dashboard page
        this.loadCxoneDashboardsDropdown();
    }

    async ngOnInit() {
        this.dashboardService.availableDashboards.forEach((d, i) => {
            this.dashboardIndices.set(d.DashboardKey, i);
        });
        this.dashboardService.dashboards.forEach((d, i) => {
            if (d) this.openDashboardIndices?.set(d.DashboardKey, i);
        });

        if (this.openDashboardIndices) {
            const firstKey = [...this.openDashboardIndices.keys()][0]; //the first dashboard in open dashboard list
            if (this.dashboardService.activeDashboard.key !== firstKey)
                await this.dashboardService.setActiveDashboard(this.dashboardService.workspaceKey, firstKey, true);
        }
        await this.getActiveDashboard();
        this.lastSelectedDashboard = this.selectedDashboard;
        const filters = await this.dashboardService.getCxOneDashboardFilters(this.selectedDashboard?.DashboardKey);
        /*this.selectedFilters = {
            isValid: true,
            selection: filters === "" ? [] : JSON.parse(filters)
        };
        this.filtersApplied = this.selectedFilters.selection.length;*/
        await this.cvLocalizationService.GetSection('CXOne_Dashboard');
        await this.cvLocalizationService.GetSection('TimeZoneInfo');
        await this.cvLocalizationService.GetSection('Controls');

        this.selectDashboardText = this.getLocaleText('Select_Dashboard', 'Select Dashboard');
        this.localizationReady = true;
        this.saveOrCancelTooltip = this.getLocaleText('Save_Or_Cancel', 'Save or cancel dashboard to enable this action');
        //this.applyFiltersTooltip = this.getLocaleText('Apply_Filters_Tooltip', 'Apply filter and save dashboard to enable this action');

        await this.checkSubscriptionFeatureAvailable();

        /*this._subscriptions.push(this.revertDashboardFilters.subscribe(async () => {
            const filters = await this.dashboardService.getCxOneDashboardFilters(this.selectedDashboard?.DashboardKey);
            this.selectedFilters = {
                isValid: true,
                selection: filters === "" ? [] : JSON.parse(filters)
            };
            this.filtersApplied = this.selectedFilters.selection.length;
            this.applyDashboardFiltersReversion.emit();
        }));*/
    }

    private async checkSubscriptionFeatureAvailable() {
        this.subscriptionsFeatureEnabled = await this.featuresService.isFeatureEnabled('Feature_CXone_Subscriptions');
    }

    public onSchedulerClose = () => this.closeScheduler();

    //For Simple Select Search
    ngOnChanges(changes: SimpleChanges) {
        if (changes.filterText) {
            this.filterDashboards();
        }
        if (changes.modules) {
            if (!this.modules) return;
            if (this.modules.length === 0) {
                this.disableExport = true;
                return;
            }
            const moduleCanExport = this.modules.find(m => m.CanExportAndSubscribe === true);
            if (moduleCanExport)
                this.disableExport = false;
            else
                this.disableExport = true;
        }
    }

    ngOnDestroy() {
        this._subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    onFullscreenChanged() {
        if (this.isAnyBrowserFullscreen()) {
            this.isFullscreen = true;
        } else {
            this.isFullscreen = false;
        }
    }

    public canFilter(dashboard: DashboardResponsiveApiModel): boolean {
        // If the dashboard hasn't loaded in yet, don't allow the filter to show.
        if (typeof dashboard === "undefined" || dashboard === null)
            return false;

        // If the dashboard is not shared, you can filter it.
        if (dashboard.dashboard.RelatedDashboardID == 0) {
            return true;
        }

        // If the dashboard is shared, but you have write access or read with control access, you can filter it.
        if (dashboard.SharedWriteAccess || dashboard.SharedReadControlAccess) {
            return true;
        }

        // All other cases, you can't filter the dashboard.
        return false;
    }

    //#region permissions
    public hasCreatePermission(): boolean {
        return !!this.dashboardService.permissions["launch_cxone_dash"];
    }

    public hasViewPermission(): boolean {
        return this.hasCreatePermission() || !!this.dashboardService.permissions["launch_cxone_dash-read"];
    }
    //#endregion

    // Fullscreen Toggle
    public toggleFullscreen() {
        if (!this.isAnyBrowserFullscreen()) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement['mozRequestFullScreen']) {
                document.documentElement['mozRequestFullScreen'](); // Firefox
            } else if (document.documentElement['webkitRequestFullscreen']) {
                document.documentElement['webkitRequestFullscreen'](); // Chrome and Safari
            } else if (document.documentElement['msRequestFullscreen']) {
                document.documentElement['msRequestFullscreen'](); // IE
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document['msExitFullscreen']) {
                document['msExitFullscreen'](); // IE
            } else if (document['mozCancelFullScreen']) {
                document['mozCancelFullScreen'](); // Firefox
            } else if (document['webkitExitFullscreen']) {
                document['webkitExitFullscreen'](); // Chrome and Safari
            }
        }
    }

    public isAnyBrowserFullscreen() {
        return document.fullscreenElement ||
            document['mozFullScreenElement'] ||
            document['webkitFullscreenElement'] ||
            document['msFullscreenElement'];
    }
    //#endregion Fullscreen Toggle

    //#region Dashboard Simple Select/Open
    public getCxoneDashboards() {
        const allCxoneDashboards = this.dashboardService.availableDashboards.filter(d => d.IsCXOne === true);
        const favoritedDashboards = (allCxoneDashboards.filter(d => d.IsFavorite === true))
            .sort((a, b) => (a.DashboardName.localeCompare(b.DashboardName, undefined, { sensitivity: "base" })));
        const notFavoritedDashboards = (allCxoneDashboards.filter(d => d.IsFavorite === false))
            .sort((a, b) => (a.DashboardName.localeCompare(b.DashboardName, undefined, { sensitivity: "base" })));

        this.availableCxoneListDashboards = favoritedDashboards.concat(notFavoritedDashboards);
    }

    /**
     * Load the list of CXone dashboards for the dashboard selection dropdown list
     * Retrieves all CXone dashboards from the dashboard service,
     * filters and sorts them based on favorite status and dashboard name,
     * and assigns the sorted list to the availableCxoneListDashboards property.
     */
    async loadCxoneDashboardsDropdown() {
        const allCxoneDashboards = await this.dashboardService.loadCxoneDashboardDropdownList();
        const favoritedDashboards = (allCxoneDashboards.filter(d => d.IsFavorite === true))
            .sort((a, b) => (a.DashboardName.localeCompare(b.DashboardName, undefined, { sensitivity: "base" })));
        const notFavoritedDashboards = (allCxoneDashboards.filter(d => d.IsFavorite === false))
            .sort((a, b) => (a.DashboardName.localeCompare(b.DashboardName, undefined, { sensitivity: "base" })));
        
        this.availableCxoneListDashboards = favoritedDashboards.concat(notFavoritedDashboards);
    }

    public async selectDashboard(dashboard: DashboardSelectionListApiModel, workspaceKey) {
        const needConfirmationToClose = this.dashboardService.dashboards.some(d => d?.NeedConfirmationToClose);
        if (needConfirmationToClose) {
            const headerText = this.getLocaleText("Confirm_Redirect_Header", "Leave Page?");
            const messageText = this.getLocaleText("Confirm_Redirect_Message1", "You have unsaved changes.") + " \n" +
                this.getLocaleText("Confirm_Redirect_Message2", "Are you sure you want to leave without saving?");

            this.CVDialogService.showConfirmDialog(
                headerText,
                messageText,
                true,
                () => this.changeToDashboard(dashboard, workspaceKey),
                () => this.selectedDashboard = this.lastSelectedDashboard
            );
            return false;
        }
        /*if (this.isFiltersApplyButtonEnabled) {
            const modal = this.dialogService.open(MessageModalComponent, {
                width: "420px",
                height: "168px",
                data: {
                    title: this.getLocaleText("Leave", "Leave"),
                    type: "user-warning",
                    message: `<div class="msg-line-1"> ` + this.getLocaleText("Cancel_Modal_Lost_Changes", "All changes will be lost.") + ` </div>`,
                    primaryButtonText: this.getLocaleText("Leave", "Leave"),
                    closeButtonText: this.getLocaleText("Stay", "Stay"),
                },
            });
            modal.onClose.subscribe((leave) => {
                if (leave) {
                    sendMessageCXOne({ hasNonSavedChanges: false });
                    this.changeToDashboard(dashboard, workspaceKey);
                } else {
                    this.selectedDashboard = this.lastSelectedDashboard;
                }
            });
            return false;
        }*/
        else {
            this.changeToDashboard(dashboard, workspaceKey);
        }
    }

    public filterDashboards() {
        if (!this.filterText)
            return true;
        const searchString = this.filterText.toLowerCase();
        return this.dashboardService.availableDashboards.filter(dashboard => dashboard.DashboardName.toLowerCase().includes(searchString));
    }

    public async getActiveDashboard() {
        this.selectedDashboard = await this.dashboardService.getActiveDashboard();
        this.lastSelectedDashboard = this.selectedDashboard;
    }

    //#region Add Filter
    /*public toggleAddFilter() {
        this.isFilterOpen = !this.isFilterOpen;
    }*/
    //#endregion

    //#region Add Module
    canAddWidget(dashboardModel: DashboardResponsiveApiModel): boolean {
        if (!this.hasCreatePermission()) {
            return false;
        }

        // this variable must be truthy - set by adding the cv-display-modules attribute directive to an element
        if (!this.navigationService.displayModules) {
            return false;
        }

        // If the dashboard is null, you can't add widgets to it
        if (!dashboardModel?.dashboard) {
            return false;
        }
        
        // If the dashboard is a temporary dashboard, it can have widgets added to it
        if (dashboardModel?.dashboard.TemporaryDashboard) {
            return true;
        }

        // If the dashboard is not shared, you are the owner and can add widgets to it.
        if (dashboardModel?.dashboard.RelatedDashboardID == 0) {
            return true;
        }

        // If the dashboard is shared and you are the owner, or if you have write access, you can add widgets to the dashboard
        return dashboardModel?.SharedOwner || dashboardModel?.SharedWriteAccess;
    };

    public toggleAddWidget() {
        this.isAddingWidgets = !this.isAddingWidgets;
        this.addingWidget.emit(event);
    }
    //#endregion

    //#region Export
    public canExport(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        return this.hasViewPermission();
    }

    public async export(dashboardApiModel: DashboardResponsiveApiModel, format: ModuleManagerExportFormat) {
        if (!this.canExport(dashboardApiModel))
            return;

        const formatDetails = this.exportFormats[format];
        const fileName = dashboardApiModel.dashboard.DashboardName + " (" + (new Date()).toString('yyyy_MM_dd, HH:mm:ss') + ")";

        const result = await this.dashboardService.getReport(dashboardApiModel.dashboard.DashboardKey, format);
        this.moduleContainerService.downloadFile(result.data, formatDetails.mime, fileName + '.' + formatDetails.extension);
    }
    //#endregion

    //#region Subscription
    public canSubscribe(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        return this.hasViewPermission() && this.subscriptionsFeatureEnabled;
    }

    /** Sets the required variables and opens scheduler */
    public openScheduler(dashboardApiModel: DashboardResponsiveApiModel): void {
        if (!this.canSubscribe(dashboardApiModel))
            return;

        this.schedulerId = dashboardApiModel.dashboard.DashboardID;
        this.schedulerKey = dashboardApiModel.dashboard.DashboardKey;
        this.subscriptionTitle = dashboardApiModel.dashboard.DashboardName;
        this.schedulerOpened = true;
    }

    public retrieveSchedule() {
        return;
    }

    /** Updates ag-grid and closes scheduler */
    public closeScheduler() {
        this.schedulerOpened = false;
    };
    //#endregion

    //#region Edit Details
    public canEdit(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        if (!this.hasCreatePermission())
            return false;
        if (typeof dashboardApiModel === "undefined" || dashboardApiModel === null)
            return false;
        // If the dashboard is not shared, or if it is shared but has write access, you can delete it.
        return dashboardApiModel.dashboard.RelatedDashboardID == 0 || dashboardApiModel.SharedWriteAccess;
    }

    public async editDashboard(dashboardApiModel: DashboardResponsiveApiModel) {
        if (!this.canEdit(dashboardApiModel))
            return;
        const data = {
            dashboardName: dashboardApiModel.dashboard.DashboardName ?? '',
            description: dashboardApiModel.dashboard.DashboardDescription ?? '',
            folder: 'CXOne Default',
            key: dashboardApiModel.dashboard.DashboardKey,
            iscxone: dashboardApiModel.dashboard.IsCXOne
        };
        await this.dashboardService.openSaveDashboardModal(data, 'EditDashboard', false).subscribe(dashboardEdited => {
            if (dashboardEdited) {
                // Updates the name and current info of the current workspace tab:
                dashboardApiModel.dashboard.DashboardName = dashboardEdited.DashboardName;
                dashboardApiModel.dashboard.DashboardGroup = dashboardEdited.DashboardGroup;
                dashboardApiModel.dashboard.DashboardDescription = dashboardEdited.DashboardDescription;
            }
        });
    }
    //#endregion

    //#region Delete
    public canDelete(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        if (!this.hasCreatePermission()) 
            return false;

        // If the dashboard hasn't loaded in yet, don't allow the delete to show.
        if (typeof dashboardApiModel === "undefined" || dashboardApiModel === null)
            return false;

        // If the dashboard is not shared, or if it is shared but has write access, you can delete it.
        return dashboardApiModel.dashboard.RelatedDashboardID == 0 || dashboardApiModel.SharedWriteAccess;
    }

    public async deleteDashboard(dashboardApiModel: DashboardResponsiveApiModel) {
        if (!this.canDelete(dashboardApiModel))
            return;

        //this.setFiltersApplyButtonState(false);
        await this.dashboardService.removeDashboard(this.dashboardService.workspaceKey, dashboardApiModel.dashboard.DashboardKey, true);
        this.getCxoneDashboards();
        this.dashboardService.cancelPublish.next();
        if (this.availableCxoneListDashboards?.length > 0) {
            await this.changeToDashboard(this.availableCxoneListDashboards[0], this.dashboardService.workspaceKey);
        }
    }
    //#endregion

    //#region Duplicate
    public async duplicateDashboard(dashboardApiModel: DashboardResponsiveApiModel, workspaceKey) {
        if (!this.hasCreatePermission())
            return;
        const data = {
            dashboardName: 'Copy of ' + (dashboardApiModel.dashboard.DashboardName ?? ''),
            description: dashboardApiModel.dashboard.DashboardDescription ?? '',
            folder: 'CXOne Default',
            key: dashboardApiModel.dashboard.DashboardKey,
            iscxone: dashboardApiModel.dashboard.IsCXOne
        };
        await this.dashboardService.openSaveDashboardModal(data, 'CopyDashboard', false).subscribe(copiedDashboard => {
            if (copiedDashboard) {
                this.selectDashboard(copiedDashboard, workspaceKey);
            }
        });
    }
    //#endregion
    //#region Time Zone
    public canSetTimezone(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        if (!this.hasViewPermission()) return false;
        return this.timezoneService?.dataObj?.availableTimeZones?.length > 0;
    }

    public async setTimezone(dashboardApiModel: DashboardResponsiveApiModel, timezone: string = null) {
        if (!this.canSetTimezone(dashboardApiModel))
            return;

        // If not on dashboard, open dashboard
        if (dashboardApiModel.dashboard.DashboardKey !== this.dashboardService.activeDashboard.key) {
            this.openDashboard(dashboardApiModel.dashboard);
        }

        if (dashboardApiModel?.dashboard?.states?.dashboardModules?.loading)
            dashboardApiModel.dashboard.states.dashboardModules.loading = true;

        await this.timezoneService.setDashboardTimezone(dashboardApiModel.dashboard.DashboardKey, timezone); // don't need to assign since we won't publish
        // try to sync the selected dashboard with the dashboard list
        try {
            this.dashboardService.availableDashboards.find((d) => d.DashboardKey === dashboardApiModel.dashboard.DashboardKey).TimeZoneInfoName = timezone;
            this.dashboardService.dashboards.find((d) => d.DashboardKey === dashboardApiModel.dashboard.DashboardKey).TimeZoneInfoName = timezone;
        }
        catch {
            this.dashboardService.availableDashboardsChanged.emit();
        }
        finally {
            this.dashboardService.refreshTimeZoneInfo.next(dashboardApiModel.dashboard.DashboardKey);
        }
    }
    //#endregion

    /** Open dashboard */
    public async openDashboard(dashboard: Dashboard | DashboardResponsiveApiModelSparse) {
        if (dashboard) {
            if (this.dashboardService.activeDashboard.key === dashboard.DashboardKey) return;
            const workspaceKey = this.dashboardService.workspaceKey;
            await this.dashboardService.clearWorkspace(workspaceKey);
            this.dashboardService.triggerActiveDashboardChanged(dashboard.DashboardKey, this.dashboardService.activeDashboard.key);
            this.dashboardService.activeDashboard.key = dashboard.DashboardKey;
            this.dashboardService.setActiveDashboard(this.dashboardService.workspaceKey, dashboard.DashboardKey, true);
        }
        else {
            this.dashboardService.setActiveDashboard(this.dashboardService.workspaceKey, null);
        }
    }
    //#endregion

    //#region New CXOne Dashboard
    public async createNewDashboard(workspaceKey) {
        if (!this.hasCreatePermission())
            return;
        const data = {
            dashboardName: '',
            description: '',
            folder: 'CXOne Default',
            key: workspaceKey,
            iscxone: true,
        };
        await this.dashboardService.openSaveDashboardModal(data, 'NewDashboard', false).subscribe(newDashboard => {
            if (newDashboard) {
                this.selectDashboard(newDashboard, workspaceKey);
            }
        });
    }
    //#endregion

    //#region New CXOne Dashboard from a Template
    public openFromTemplate() {
        this.navigationService.showOverlay = true;
        this.modalRef = this.ngbModal.open(TemplateListModalComponent, { size: "from-template", centered: true, scrollable: true, modalDialogClass: 'cx-one-ui' });
        this.modalRef.result.finally(() => this.navigationService.showOverlay = false);
    }
    //#endregion

    //#region Share CXOne Dashboard
    public canShare(dashboardApiModel: DashboardResponsiveApiModel): boolean {
        // If you don't have create permission, you can't share the dashboard.
        if (!this.hasCreatePermission()) 
            return false;        

        // If the dashboard hasn't loaded in yet, don't allow sharing.
        if (typeof dashboardApiModel === "undefined" || dashboardApiModel === null)
            return false;

        // If the dashboard is not shared, you can share it.
        if (dashboardApiModel.dashboard.RelatedDashboardID == 0) {
            return true;
        }

        // If the dashboard is shared, but you have write access, you can share it.
        if (dashboardApiModel.SharedWriteAccess) {
            return true;
        }

        // All other cases, you can't share the dashboard.
        return false;
    }

    public async cxoneShare(dashboardApiModel: DashboardResponsiveApiModel) {
        if (!this.canShare(dashboardApiModel))
            return;

        const dashboardApiModelSparse = await this.dashboardService.loadDashboardShareInfo(dashboardApiModel.dashboard.DashboardKey);

        const option: DashboardAccessOptions = {
            // dashboard: this.dashboardService.availableDashboards.find(d => d.DashboardKey === this.dashboardService.activeDashboard.key),
            dashboard: dashboardApiModelSparse
        };

        const shareModal = this.dashboardAccessService.openModal(option, DashboardAccessComponent);
        shareModal.result.then(async (dashboardResult: DashboardResponsiveApiModelSparse) => {
            const dashboardIndex = this.dashboardService.availableDashboards.findIndex(d => d.DashboardKey === dashboardResult.DashboardKey);
            this.dashboardService.availableDashboards[dashboardIndex] = dashboardResult;

            //Process of clearing the workspace and reading the selected dashboard
            const workspaceKey = this.dashboardService.workspaceKey;
            await this.dashboardService.clearWorkspace(workspaceKey, true);
            this.dashboardService.clearDashboardsFromWorkspace();
            //this setTimeout is necessary to correctly reload the dashboard, if this is not used the widgets won't be reloaded because clearWorkspace and clearDashboardsFromWorkspace functions and addDashboardToWorkspace function will overlap
            setTimeout(() => {
                this.dashboardService.addDashboardToWorkspace(workspaceKey, this.selectedDashboard, true, true);
            }, 1);
            this.lastSelectedDashboard = dashboardApiModel.dashboard;
        });
    }

    //#region Subscription CXOne
    public cxoneSubscription() {
        const existingSubscription = this.dashboardSubscriptions.get(this.dashboardService.getActiveDashboard().DashboardKey);
        const activeDashboard = this.dashboardService.getActiveDashboard();
        const option: SubscriptionOptions = {
            embedMode: false,
            reportType: existingSubscription?.ReportSubscriptionSchedule ? existingSubscription.ReportSubscription.ReportType : 0,
            subscriptionId: existingSubscription?.ReportSubscriptionSchedule
                ? existingSubscription.ReportSubscription.ReportSubscriptionID : -1,
            existingSchedule: existingSubscription?.ReportSubscriptionSchedule ? existingSubscription.ReportSubscription : null,
            subscriptionTitle: existingSubscription?.ReportSubscription.ReportSubscriptionName.length > 0
                ? existingSubscription.ReportSubscription.ReportSubscriptionName : activeDashboard.DashboardName,
            relatedId: activeDashboard.DashboardID,
            dashboardKey: activeDashboard.DashboardKey,
        };
        const modalInstance = this.subscriptionService.openModal(option, SubscriptionModalComponent);
        modalInstance.componentInstance.saved
            .subscribe((schedule: FullSubscriptionSchedule) => this.dashboardSubscriptions
                .set(schedule.ReportSubscription.RelatedKey, schedule));
    }

    public async loadSubscriptions() {
        this.dashboardSubscriptions = new Map<string, FullSubscriptionSchedule>();
        await this.dashboardService.loadExistingDashboardsAndGroups();

        this.dashboardService.availableDashboards.forEach(async d => {
            const subscription = await this.schedulerService.getSubscriptionScheduleByRelatedKeyAndID(d.DashboardKey, d.DashboardID);

            this.dashboardSubscriptions.set(d.DashboardKey, subscription);
        });
    }

    public async loadActiveDashboardSubscription() {
        // Get the active dashboard
        const activeDashboard: Dashboard = this.dashboardService.getActiveDashboard();

        // set the dashboard subscriptions map object so it isn't null later
        this.dashboardSubscriptions = new Map<string, FullSubscriptionSchedule>();

        // If no active dashboard, don't attempt to load subscription since there won't be one.
        if (activeDashboard == null)
            return;

        // Load the subscription in for the active dashboard
        const subscription = await this.schedulerService.getSubscriptionScheduleByRelatedKeyAndID(activeDashboard.DashboardKey, activeDashboard.DashboardID);

        // Set the subsctiption in the map
        this.dashboardSubscriptions.set(activeDashboard.DashboardKey, subscription);
    }

    public checkSubscription(): boolean {
        const d = this.dashboardService.getActiveDashboard();
        const s = this.dashboardSubscriptions.get(d.DashboardKey);

        if (s && s.ReportSubscription.ReportSubscriptionID !== -1) {
            return true;
        }

        return false;
    }

    public async deleteSubscription() {
        const existingSubscription = this.dashboardSubscriptions.get(this.dashboardService.getActiveDashboard().DashboardKey);
        const option: SubscriptionOptions = {
            embedMode: false,
            reportType: 1,
            subscriptionId: existingSubscription.ReportSubscription.ReportSubscriptionID,
            existingSchedule: existingSubscription.ReportSubscription,
            subscriptionTitle: existingSubscription.ReportSubscription.ReportSubscriptionName,
            relatedId: existingSubscription.ReportSubscription.RelatedID,
            dashboardKey: this.dashboardService.activeDashboard.key,
        };
        const modal = this.subscriptionDeleteService.openModal(option, DeleteSubscriptionComponent);
        // modal.componentInstance.deleted.subscribe(() => this.loadSubscriptions());
        modal.componentInstance.deleted.subscribe(() => this.loadActiveDashboardSubscription());
    }

    /**
     * Changes the active dashboard to the specified dashboard selection item.
     * @param dashboardSelectionItem - The selected dashboard item.
     * @param workspaceKey - The key of the workspace.
     */
    private async changeToDashboard(dashboardSelectionItem: DashboardSelectionListApiModel, workspaceKey) {
        if (dashboardSelectionItem) {

            // If the same dashboard that was picked is the open dashboard, don't switch and just return
            if (this.dashboardService.activeDashboard.key === dashboardSelectionItem.DashboardKey) 
                return;

            let targetDashboard: Dashboard = null;

            try {
                await this.dashboardService.clearWorkspace(workspaceKey, true);
                this.dashboardService.clearDashboardsFromWorkspace();                

                // Create the dashboard since it doesn't exist yet. This is a shared dashboard you have never looked at.
                if (dashboardSelectionItem.DashboardKey === "") {
                    dashboardSelectionItem = await this.dashboardService.createDashboard(dashboardSelectionItem);
                }
                
                const loadResponse = await this.dashboardService.loadDashboard(dashboardSelectionItem.DashboardKey);
                if (loadResponse) {
                    targetDashboard = loadResponse.dashboard;
                }
            }
            finally {
                if (!targetDashboard){
                    console.error("Error loading dashboard: " + dashboardSelectionItem.DashboardKey);
                }
                else {
                    this.dashboardService.addDashboardToWorkspace(workspaceKey, targetDashboard, true, true);
                    this.lastSelectedDashboard = dashboardSelectionItem;
                }
            }
        }
    }

    private getLocaleText(key: string, defaultValue?: string) {
        return this.cvLocalizationService.getCachedText("CXOne_Dashboard", key, defaultValue);
    }

    showSelectedTimeZone(timezone: string) {
        let activeTimezone: string;
        let defaultTimezone = this.timezoneService.dataObj.defaultCompanyTimeZone;

        activeTimezone = timezone === 'Not Set' ? this.cvLocalizationService.getCachedText("TimeZoneInfo", defaultTimezone, defaultTimezone) 
            : this.cvLocalizationService.getCachedText("TimeZoneInfo", timezone, timezone);
        
        return activeTimezone + ' (' + this.cvLocalizationService.getCachedText("Controls", "default", "Default") + ')';
    }

    //endregion

    /*applyFilters($event: any) {
        this.selectedFilters = $event;
        this.filtersApplied = this.selectedFilters.selection.length;
        const activeDashboard = this.dashboardService.getActiveDashboard();
        this.dashboardService.setCxOneDashboardFilters(activeDashboard.DashboardKey, this.selectedFilters.selection);
        this.isFilterOpen = false;
    }

    updateFilterAppliedText($event: any){
        this.filtersApplied = $event;
    }

    setFiltersApplyButtonState($event: any) {
        this.isFiltersApplyButtonEnabled = $event;
        this.disableDuplicateAndCreate = this.isFiltersApplyButtonEnabled;
        if (this.isFiltersApplyButtonEnabled) {
            sendMessageCXOne({ hasNonSavedChanges: true });
        } else {
            sendMessageCXOne({ hasNonSavedChanges: false });
        }
    }*/
}
